require('gsap');
require('./plugins/MorphSVGPlugin');

var ScrollMagic = require('ScrollMagic');
require('animation.gsap');
require('debug.addIndicators');

const ATTR_NAME = 'data-external-svg';

const CLIENTS_SVG = require('./svg/CLIENTS_SVG.svg');

const smController = new ScrollMagic.Controller();


const _animate = () => {
  //TODO: run animations for logos
	const scrollScene = new ScrollMagic.Scene({
    triggerElement: "#logoTrigger"
  });

	const timeline = new TimelineMax();

	// animate logos sequentially
	const logos = ".client-list__logo";
	timeline.add(
		TweenMax.staggerFrom(logos, .75, {opacity: 0}, .25)
	);

	scrollScene.setTween(timeline).addTo(smController);

};

const _load = () => {

  if (CLIENTS_SVG) {
    const ajax = new XMLHttpRequest();
    ajax.open("GET", CLIENTS_SVG, true);
    ajax.send();
    ajax.onload = function (e) {
      var div = document.createElement("div");
      div.innerHTML = ajax.responseText;
      document.body.insertBefore(div, document.body.childNodes[0]);
      _animate();
    }
  }


  else {
    console.warn('CLIENTS SVG ' + CLIENTS_SVG + ' not available');
  }


};


const initializeSVGClients = () => {

  _load();


};


export default initializeSVGClients;



/** WEBPACK FOOTER **
 ** ./src/script/svganimations/clients.js
 **/